import script from "./DetalleTorneoView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetalleTorneoView.vue?vue&type=script&setup=true&lang=ts"

import "./DetalleTorneoView.vue?vue&type=style&index=0&id=98497bfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98497bfe"]])

export default __exports__